import { Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import RTTable from "../../../components/Comman/RT/RTTable";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import { noInternetMsg } from "../../../config/messageconstant";
import { getCrnHeaderId } from "../../../Slice/creditNote.slice";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import endpoint from "../../../config/endpoints";
import { apiGet } from "../../../utils/api_service";
import { Data } from "@react-google-maps/api";
class StockTransferView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
      stockTransferData: [],
    };
    this.columns = [
      {
        title: "Sr.No.",
        name: "index",
        align: "center",
      },
      {
        title: "Product Name",
        name: "productName",
      },
      {
        title: "UOM",
        name: "stakeHolderUom",
        align: "center",
      },
      {
        title: "Primary Qty",
        name: "primaryQty",
        align: "right",
      },
      {
        title: "Secondary Qty",
        name: "secondaryQty",
        align: "right",
      },
      {
        title: "Total Qty",
        name: "totalQty",
        align: "right",
      },
    ];
  }

  async componentDidMount() {
    const { getCrnHeaderId, showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      if (this.props.params.id) {
        showLoador({ loador: true });
        apiGet({
          url: endpoint.stockTransferInOutHeader + "/" + this.props.params.id,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          console.log(data);
          if (!success) {
          } else {

            let stockTransferData = data.data.stockTransferInOutDetails.map((item, index) => {
              let primaryQty = item.primaryQty ? Math.floor(item.primaryQty) : 0;
              let secondaryQty = item.secondaryQty ? item.secondaryQty % item.product.uomConversionValue : 0;

              return {
                index: index + 1,
                id: item.id,
                date: item.date || "",
                productName: item.productName || item.product?.name || "",
                stakeHolderUom: item.product?.stakeHolderUom?.name || "",
                primaryQty: primaryQty,
                secondaryQty: secondaryQty,
                totalQty:
                  +primaryQty * item.product?.uomConversionValue +
                  +secondaryQty,
              }
            });

            this.setState({
              stockTransferData,
              DataToSet: [
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Transfer No",
                  value:
                    data.data.transferNo !== null ? data.data.transferNo : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Date",
                  value: data.data.date !== null ? data.data.date : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Stock Holder",
                  value:
                    data.data.stockStakeHolder.firmName !== null
                      ? data.data.stockStakeHolder.firmName
                      : "",
                },
              ],


            });
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  render() {
    const { dynamicMasterData, stockTransferData, DataToSet } = this.state;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showTitle={true}
            screenTitle={"Stock Transfer View"}
            saveBtnText={"Search"}
            showSaveBtnMain={false}
          />

          <RTTable
            columns={this.columns}
            tableData={stockTransferData}
            isActionColActive={false}
            showPegination={false}
          />
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
  getCrnHeaderId,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(StockTransferView);
